import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth44: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.4,379.4c73-16.5,120.9-1,120.9-1l9.9,44,1.6,11.4-.9,12.9-2,5.2-3.7,4.5-5.2,3-3.9,9.5-18.1,16.1-6.8.6h-15s-8.8-.8-8.8-.8l-13.3,8.1-23.9-7.3-43.2-32.2-2.3-3.3-2.3-5.7-.9-6.3,1.4-8.5,16.5-50.2h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M149.7,370.2c-50.6-19.2-116.7.6-116.7.6l-2.6,8.6c73.2-16.5,120.9-1,120.9-1,0,0-1.6-8.2-1.6-8.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154.9,394.4l8.1,45.3-1.3,8.4-4,7.1-6.8,4.8-3.5,8.8-18.7,17.6h-13s-.2-79.6-.2-79.6c0-12.8,10.5-12.7,10.5-12.7l29,.2h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.9,395.7l-8.2,23.4-4.5,18.7.8,3.5,1.2,5.6,2.9,6.6,4.5,3.5,9,5.6,30,23.9,6.4,1.9,1.2-80.4c0-12.8-9.7-12.7-9.7-12.7l-33.5.2v.2Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M67,453.6l48.7.3s-.2-34-.2-47.1,10.5-12.7,10.5-12.7l29,.2-3.7-15.9c-58.8-15.9-120.9,1-120.9,1l-5.3,16.1,33.5-.2s9.7-.2,9.7,12.7l-1.2,45.6h0Z',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '158.3 454.6 150.5 460.6 147.1 469.2 127.7 485.6 121.9 486.5 107.1 486.5 99 484.9 85 493.7 60.9 486 52.8 480.5 31.4 463.6 17.6 453.9 67.1 453.9 115.7 453.9 158.3 454.6',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.4,379.4c73-16.5,120.9-1,120.9-1l9.9,44,1.6,11.4-.9,12.9-2,5.2-3.7,4.5-5.2,3-3.9,9.5-18.1,16.1-6.8.6h-15s-8.8-.8-8.8-.8l-13.3,8.1-23.9-7.3-43.2-32.2-2.3-3.3-2.3-5.7-.9-6.3,1.4-8.5,16.5-50.2h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'13.7 439 28.6 416 36.1 448 46.1 409.1 59.2 449 71.2 409.1 84.6 448.6 97 409.1 110.7 451 121.6 411.1 136.1 451 140.5 417.5 159.1 438',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'89.5 388.3 103.3 379.2 86.3 370.5 100.2 361.3 84.5 353.2 97.7 344.4 83.6 337.2 96.4 328.7 80.2 320.4 92.8 312.2 79.8 305.6 92.4 297.3 78.2 290.1 91.5 281.3 78.2 274.6 91.5 265.8 79 259.3 92 250.8 76.9 243.1 92.1 233.1 77.6 225.5 92.6 215.7 77.5 208 92.3 198.3 75.3 189.5 88.8 180.5 72.9 172.3 89.1 161.8 74 154 88.6 144.4 72.6 136.3 88 126.1 72.3 118 86.7 108.6 70.3 100.2 84.6 90.6 68.5 82.3 82.8 72.9 65.7 54.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'51.9 245.7 57.1 233.2 63.4 246.2 69.9 234.5 77.6 245.3 86.8 232.5 95.2 247.8 105.4 233.2 115.3 247.8 123.6 234.5 132.3 247.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '150.9 97.8 152.5 116.6 147.9 134.8 134.4 153.1 110.3 167.5 91.4 172.6 75.9 172.3 55.2 168.1 29.6 156 17.5 143.2 8.7 123.4 6.3 112.4 7.6 91.9 11.8 73.7 21.9 55 41.3 39.8 61 33.2 83.5 34.1 99.8 39.4 113.5 48.6 142.1 79.5 150.9 97.8',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.4,85.2s-3.6,7.5-15.9,7.5c-12.3,0-16.6-8.2-28.2-8.2-11.6,0-17.9,8.4-35.4,8.4s-13.5-9-13.5-9l-13.7-13.6,8.8-15.3,17.6-15.2,20.9-6.4,23,.4,19.3,6.9,17.2,12.3,15.2,17.6-15.3,14.6Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M13.4,136.7l16.9-16.2s3.6-7.5,15.9-7.5,16.6,8.2,28.2,8.2,17.9-8.4,35.4-8.4,13.5,9,13.5,9l19.6,18.7-8.4,12.2-22.4,13.1-19.6,6.2-20.4.4-19.1-3.7-23.6-12.5-9.5-8.6-6.5-10.8h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M134.7,70.7l-15.3,14.6c-10.5,23.4,3.9,36.7,3.9,36.7l19.6,18.7,5.8-7.9,2.6-10.7.6-10.1-1.3-15.5-6.7-13.7-9.2-12.2h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12.5,70.2l13.7,13.6c15.1,21.2,3.9,36.7,3.9,36.7l-16.9,16.2-3.6-8.3-1.1-6.5-2.4-8.4.2-15.3.7-5.2,2.1-10.5,3.6-12.2h-.2Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.3,85.2c-10.5,23,3.9,36.7,3.9,36.7,0,0,5.6-9.2-13.5-9-19.1.2-22.4,8.4-35.4,8.4-13,0-15.5-8.2-28.2-8.2-8,0-15.9,7.5-15.9,7.5,10.9-18.9-3.9-36.7-3.9-36.7,0,0-4.3,9,13.5,9s24.4-8.4,35.4-8.4,20.7,8.2,28.2,8.2,15.9-7.5,15.9-7.5h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.2,133.6l-14.2,19.9-23.5,13.7-11.1,3.7-9.5,1.9-15.7-.2-19.5-4.2-25.1-12.3-12.6-12.9-4.4-9.7c69.9,20.9,135.4,0,135.4,0h.2Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.2,64.6c-58.1-10.6-113.2,0-113.2,0l7.5-12.1,17.6-13.9,18.5-5.3,23.7.8,17.3,5.9,14.5,8.9,14.2,15.7h-.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'8.7 95.9 23 117.8 30.2 87.3 39.7 124.6 52.2 86.3 63.7 124.6 76.6 86.8 88.6 124.6 101.4 84.4 112 122.6 125.8 84.4 130.1 116.4 147.9 96.8',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.7,131.7s-67.3,48-122.8,5.3l-16.6-42.9-1.9-7.7-.2-12.3,7.6-11.3,9.8-9.6,37.8-31.3,26-9.3,29.7,12.6,16,12.7,22.1,14.4,2.8,7.4,1.1,6.5-.4,7.5-11,57.9h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.8,131.6l-2.4,13.1c-67.5,43.7-114.3,7.6-114.3,7.6l-6.2-15.4c55.7,42.7,122.8-5.3,122.8-5.3h.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.7,131.7l3.4-17.6h-29.3c-13.4,0-12.4-15.1-12.4-15.1v-38.8s-50.9,0-50.9,0v39.8c0,11.5-13,13.6-13,13.6h-29.9s9.3,23.3,9.3,23.3c55.5,42.7,122.8-5.3,122.8-5.3h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.5,60.2s-.1,22.5,0,38.8c.1,16.3,12.4,15.1,12.4,15.1h29.3s6.6-38.1,6.6-38.1l-.2-17.1-4.8-7.6-21.7-14.6-21.7-16.5v40s0,0,0,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M59.4,60.2v39.8c0,11.5-13,13.6-13,13.6h-29.9s-10.6-26.2-10.6-26.2l.2-12.9,5.4-10.2,9.9-9.4L59.5,22.1v38.1h0Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.3,60.3c-.9,0,47.9-.3,47.9-.3l-3.9-8.1-23.6-16.2-14-12.5-29.7-11.4-28.7,11.2L16.3,60.2h94.1s-.1.1-.1.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.7,131.7s-67.3,48-122.8,5.3l-16.6-42.9-1.9-7.7-.2-12.3,7.6-11.3,9.8-9.6,37.8-31.3,26-9.3,29.7,12.6,16,12.7,22.1,14.4,2.8,7.4,1.1,6.5-.4,7.5-11,57.9h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.8 77.1 24 100.2 31.6 67.9 41.6 107.3 54.7 66.9 66.9 107.3 80.6 67.4 93.1 107.3 106.8 64.8 117.8 105.2 132.5 64.8 137 98.6 155.6 78',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'97.4 134.3 83.6 140.6 98.3 150.3 84 156.8 97.7 165.7 84.4 171.8 96.6 179.8 83.4 185.7 97.6 194.8 84.9 200.6 96.1 207.9 83.4 213.7 95.6 221.7 82.2 227.8 93.8 235.4 80.2 241.5 91 248.4 77.8 254.6 90.9 263 75.5 270.1 88.1 278.3 72.9 285.2 85.8 293.7 70.8 300.5 85.8 310.2 72 316.5 85.7 325.5 69.4 332.9 82.4 341.5 67.7 348.1 81.6 357.2 65.7 364.2 79.5 373.1 64.9 379.7 79.3 389 64.5 395.8 78.5 404.9 63.9 411.5 77.7 429.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'49.9 252.1 55.6 267.4 62.1 251.2 69 265.9 77.2 252.5 87 268.2 95.9 249.3 106.6 267.4 117.1 249.3 126 265.9 135.1 249.7',
			],
		},
	},
};
